import * as R from 'ramda'
import React, { useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import { useSession } from 'context/Session'
import Header from 'routes/Dashboard/components/Header/Header'
import { PostModal } from 'components/collections/Post'

import * as S from './Profile.styles'

const defaultProps = {}
const propTypes = {}

export const Profile = props => {
  const router = useRouter()
  const { username, data, postData } = props
  const { user } = useSession()
  const { tab = 'published', page = 1, post } = router.query

  const [lastRoute, setLastRoute] = useState(null)

  const hasFollow = useMemo(() => {
    return user && user?.profile?.username !== username
  }, [username, user])

  const onPostClose = () => {
    router.push(lastRoute || `/p/${username}/`, undefined, {
      shallow: !!lastRoute,
    })
  }

  const onPostOpen = () => {
    setLastRoute(`/p/${username}?tab=${tab}&page=${page}`)
  }

  return (
    <S.Container>
      {post && (
        <PostModal postId={post} data={postData} onClose={onPostClose} />
      )}
      {!R.isEmpty(data) && (
        <Header
          key={`${username}-profile-header`}
          profile={data}
          hasFollow={hasFollow}
          disableEdit
        />
      )}
      {!post && (
        <S.Content>
          <S.ArticleTabs
            key={`${username}-tabs`}
            {...props}
            onPostOpen={onPostOpen}
          />
        </S.Content>
      )}
    </S.Container>
  )
}

Profile.defaultProps = defaultProps
Profile.propTypes = propTypes

export default Profile
